import { useCurrentSpaceContext } from "@circle-react/contexts/currentSpaceContext";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import { useSpaceSlugFromUrl } from "@circle-react/hooks/useSpaceSlugFromUrl";

export const toSpaceId = (value?: unknown): number | undefined => {
  if (value == null || value === "") return undefined;
  if (typeof value === "number") return value;
  const id = Number(value);
  return id > 0 ? id : undefined;
};

export const useQuickPostSpaceId = (
  explicitSpaceId?: string | number,
): number | undefined => {
  const fromProp = toSpaceId(explicitSpaceId);
  const spaceSlug = useSpaceSlugFromUrl();
  const { data } = useCurrentSpaceContext();
  const { helpers } = useSpacesContext();

  if (fromProp !== undefined) return fromProp;
  if (!spaceSlug) return undefined;

  const space = helpers.findBy({ slug: spaceSlug });
  if (space?.id) return space.id;

  return data?.id ?? undefined;
};
